/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Setup state of a survey replacing a previous edition within the survey season. Any active replacement that has started but is not yet published (draft, failed, scheduled or publishing) reads as `inProgress`; a published replacement is `done`. Derived entirely from the replacement and the new edition's load state -- the user cannot set it by hand. "Mark as Complete" is a profile-job-library statement (SurveySeasonReplacementGroup.setupCompletedAt) and deliberately does not reach the surveys under it.
 */
export enum SurveySeasonSurveySetupStatus {
    DONE = 'done',
    READY_TO_SET_UP = 'readyToSetUp',
    AWAITING_DATA_UPLOAD = 'awaitingDataUpload',
    IN_PROGRESS = 'inProgress',
}
